<template>
    <div class="row justify-content-center align-self-center prev-next">
        <b-col class="btn-prev-next">
            <b-button
                    block
                    variant="secondary"
                    size="lg"
                    @click="handlePrev"
                    :disabled="prevDisabled"
            >
                {{ prevLabel }}
            </b-button>
        </b-col>
        <b-col class="align-self-center">
            <div class="line" />
        </b-col>
        <b-col class="btn-prev-next">
            <b-button
                    block
                    variant="primary"
                    size="lg"
                    @click="handleNext"
                    :disabled="nextDisabled"
            >
                {{ nextLabel }}
            </b-button>
        </b-col>
    </div>
</template>
<script>
    export default {

        props: {
            prevDisabled: {
                type: Boolean,
                default: false
            },
            nextDisabled: {
                type: Boolean,
                default: false
            },
            prevLabel: {
                type: String,
                default: 'Prev'
            },
            nextLabel: {
                type: String,
                default: 'Next',
            },
        },

        methods: {
            handlePrev() {
                this.$emit('prevClicked');
            },
            handleNext() {
                this.$emit('nextClicked');
            },
        },
    };
</script>
<style
        lang="scss"
        scoped
>
    @import '~bootstrap/scss/functions';
    @import "../scss/_variables.scss";

    .prev-next {
        // width: $prev-next-width;
    }

    .btn-prev-next {
        padding: $prev-next-btn-padding;
    }

    .line {
        background-color: $gray-400;
        height:           $prev-next-line-height;
        // width: $prev-next-line-width;
        margin:           $prev-next-line-margin;
    }
</style>
